<template>
  <div class="min-h-screen bg-[#f6f7f9] py-10">
    <div class="max-w-[900px] mx-auto px-6">

      <!-- Header card -->
      <div class="bg-white rounded-2xl border border-[#e9eaec] shadow-sm overflow-hidden mb-6">
        <div class="h-1 bg-gradient-to-r from-[#FFD500] to-[#FFC107]"></div>
        <div class="px-8 py-8">
          <nav class="flex items-center gap-2 text-[0.82rem] text-[#999] mb-4">
            <router-link to="/" class="hover:text-[#111] transition-colors no-underline"><i class="bi bi-house"></i></router-link>
            <i class="bi bi-chevron-right text-[0.7rem]"></i>
            <span class="text-[#111] font-medium">Contact</span>
          </nav>
          <h1 class="text-[2rem] font-extrabold text-[#111] mb-2 leading-tight">Contact</h1>
          <p class="text-[#666] text-[0.9375rem]">Vragen? Wij helpen je graag. Bereik ons via onderstaande gegevens of stuur een bericht.</p>
        </div>
      </div>

      <div class="grid md:grid-cols-2 gap-6">

        <!-- Contactgegevens -->
        <div class="bg-white rounded-2xl border border-[#e9eaec] shadow-sm p-8 flex flex-col gap-5">
          <h2 class="text-[1.125rem] font-bold text-[#111] mb-2">Onze gegevens</h2>

          <div class="flex items-start gap-3">
            <span class="w-9 h-9 rounded-lg bg-[#fffbe6] flex items-center justify-center shrink-0"><i class="bi bi-envelope text-[#FFD500]"></i></span>
            <div>
              <p class="text-[0.78rem] font-semibold text-[#888] uppercase tracking-wide mb-0.5">E-mail</p>
              <a href="mailto:info@plug2charge.nl" class="text-[0.9375rem] font-medium text-[#111] no-underline hover:text-[#b8860b] transition-colors">info@plug2charge.nl</a>
            </div>
          </div>

          <div class="flex items-start gap-3">
            <span class="w-9 h-9 rounded-lg bg-[#fffbe6] flex items-center justify-center shrink-0"><i class="bi bi-chat-dots text-[#FFD500]"></i></span>
            <div>
              <p class="text-[0.78rem] font-semibold text-[#888] uppercase tracking-wide mb-0.5">Live chat</p>
              <a href="/klantenservice#livechat" class="text-[0.9375rem] font-medium text-[#111] no-underline hover:text-[#b8860b] transition-colors">Direct in gesprek</a>
            </div>
          </div>

          <div class="flex items-start gap-3">
            <span class="w-9 h-9 rounded-lg bg-[#fffbe6] flex items-center justify-center shrink-0"><i class="bi bi-geo-alt text-[#FFD500]"></i></span>
            <div>
              <p class="text-[0.78rem] font-semibold text-[#888] uppercase tracking-wide mb-0.5">Adres (geen bezoekadres)</p>
              <p class="text-[0.9375rem] text-[#333] mb-0">Plug2charge.nl (Slimmemeterwinkel.nl)</p>
              <p class="text-[0.9375rem] text-[#333] mb-0">Poortdijkstraat 13, 4318AL Brouwershaven</p>
              <p class="text-[0.9375rem] text-[#333] mb-0">Nederland</p>
            </div>
          </div>

          <div class="flex items-start gap-3">
            <span class="w-9 h-9 rounded-lg bg-[#fffbe6] flex items-center justify-center shrink-0"><i class="bi bi-building text-[#FFD500]"></i></span>
            <div>
              <p class="text-[0.78rem] font-semibold text-[#888] uppercase tracking-wide mb-0.5">Bedrijfsgegevens</p>
              <p class="text-[0.9375rem] text-[#333] mb-0">KVK 76253937</p>
              <p class="text-[0.9375rem] text-[#333] mb-0">BTW NL003065325B15</p>
            </div>
          </div>
        </div>

        <!-- Contactformulier -->
        <div class="bg-white rounded-2xl border border-[#e9eaec] shadow-sm p-8">
          <h2 class="text-[1.125rem] font-bold text-[#111] mb-5">Stuur een bericht</h2>

          <div v-if="sent" class="flex flex-col items-center justify-center py-8 text-center gap-3">
            <div class="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center">
              <i class="bi bi-check-lg text-green-600 text-2xl"></i>
            </div>
            <p class="font-semibold text-[#111]">Bericht verzonden!</p>
            <p class="text-[0.875rem] text-[#666]">We nemen zo snel mogelijk contact met je op.</p>
          </div>

          <form v-else @submit.prevent="submitForm" class="flex flex-col gap-4">
            <input v-model="form.website" type="text" name="website" tabindex="-1" autocomplete="off" aria-hidden="true" class="hidden" />
            <div>
              <label class="block text-[0.8125rem] font-semibold text-[#555] mb-1">Naam</label>
              <input v-model="form.name" type="text" required placeholder="Jan de Vries"
                class="w-full px-4 py-2.5 border border-[#e9ecef] rounded-lg text-[0.875rem] outline-none focus:border-[#FFD500] focus:ring-2 focus:ring-[#FFD500]/20 transition-all">
            </div>
            <div>
              <label class="block text-[0.8125rem] font-semibold text-[#555] mb-1">E-mailadres</label>
              <input v-model="form.email" type="email" required placeholder="jan@example.nl"
                class="w-full px-4 py-2.5 border border-[#e9ecef] rounded-lg text-[0.875rem] outline-none focus:border-[#FFD500] focus:ring-2 focus:ring-[#FFD500]/20 transition-all">
            </div>
            <div>
              <label class="block text-[0.8125rem] font-semibold text-[#555] mb-1">Onderwerp</label>
              <select v-model="form.subject"
                class="w-full px-4 py-2.5 border border-[#e9ecef] rounded-lg text-[0.875rem] outline-none focus:border-[#FFD500] focus:ring-2 focus:ring-[#FFD500]/20 transition-all bg-white">
                <option value="">Selecteer een onderwerp</option>
                <option>Vraag over een product</option>
                <option>Bestelling / levering</option>
                <option>Installatie advies</option>
                <option>Garantie / klacht</option>
                <option>Overig</option>
              </select>
            </div>
            <div>
              <label class="block text-[0.8125rem] font-semibold text-[#555] mb-1">Bericht</label>
              <textarea v-model="form.message" required rows="4" placeholder="Typ hier je vraag of opmerking..."
                class="w-full px-4 py-2.5 border border-[#e9ecef] rounded-lg text-[0.875rem] outline-none focus:border-[#FFD500] focus:ring-2 focus:ring-[#FFD500]/20 transition-all resize-none"></textarea>
            </div>
            <p v-if="error" class="flex items-start gap-2 text-[0.85rem] text-[#b42318] bg-[#fef3f2] border border-[#fecdca] rounded-lg px-3 py-2.5" role="alert">
              <i class="bi bi-exclamation-triangle-fill mt-0.5"></i>
              <span>{{ error }}</span>
            </p>
            <button type="submit" :disabled="sending"
              class="w-full bg-[#FFD500] hover:bg-[#ffb800] text-[#111] font-bold py-3 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
              <i v-if="sending" class="bi bi-arrow-repeat animate-spin"></i>
              <i v-else class="bi bi-send"></i>
              {{ sending ? 'Verzenden...' : (error ? 'Opnieuw proberen' : 'Verstuur bericht') }}
            </button>
          </form>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const form = ref({ name: '', email: '', subject: '', message: '', website: '' }) // website = honeypot
const sending = ref(false)
const sent = ref(false)
const error = ref('')

const submitForm = async () => {
  sending.value = true
  error.value = ''
  try {
    const res = await fetch('/api/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form.value)
    })
    if (!res.ok) {
      const data = await res.json().catch(() => ({}))
      throw new Error(data.error || 'Versturen mislukt. Probeer het opnieuw.')
    }
    sent.value = true
  } catch (e) {
    // Eerlijk zijn: bij een netwerk-/serverfout is het bericht NIET aangekomen.
    error.value = e.message || 'Er ging iets mis. Controleer je verbinding en probeer het opnieuw.'
  } finally {
    sending.value = false
  }
}
</script>
